// src/theme.js
import { createTheme } from '@mui/material/styles';

const common = {
  typography: {
    fontFamily: "'Raleway', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    button: {  fontWeight: 600 },
    h1: { fontWeight: 700, letterSpacing: '-0.015em' },
    h2: { fontWeight: 600 },
    h3: { fontWeight: 600 },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 24,
          fontWeight: 600,
          boxShadow: 'none',
          /*'&:hover': {
            boxShadow: '0 4px 12px rgba(33, 150, 243, 0.2)', // blue shadow
          },*/
        },
      },
    },
  },
};

const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1565C0', // Deep Blue
      light: '#5E92F3',
      dark: '#003C8F',
      contrastText: '#fff',
    },
    secondary: {
      main: '#FFC107', // Gold/Amber
      light: '#FFF350',
      dark: '#C79100',
      contrastText: '#222',
    },
    error: {
      main: '#D32F2F', // Red 700
      light: '#FF6659',
      dark: '#9A0007',
      contrastText: '#fff',
    },
    warning: {
      main: '#ED6C02', // Orange 800
      light: '#FF9800',
      dark: '#B53D00',
      contrastText: '#000',
    },
    info: {
      main: '#0288D1', // Blue 700
      light: '#03A9F4',
      dark: '#01579B',
      contrastText: '#fff',
    },
    success: {
      main: '#2E7D32', // Green 800
      light: '#60AD5E',
      dark: '#005005',
      contrastText: '#fff',
    },
    background: {
      default: '#F7F7F7', // Soft off-white background
      paper: '#ffffff',
    },
    text: {
      primary: '#484848', // Medium dark gray text
      secondary: '#757575',
    },
  },
  ...common,
});

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#42A5F5', // Lighter blue for dark mode contrast
      light: '#80D6FF',
      dark: '#0077C2',
      contrastText: '#fff',
    },
    secondary: {
      main: '#FFD54F', // Lighter gold for dark mode
      light: '#FFFF81',
      dark: '#C8A415',
      contrastText: '#222',
    },
    error: {
      main: '#EF5350', // Red 400
      light: '#FF867C',
      dark: '#B61827',
      contrastText: '#000',
    },
    warning: {
      main: '#FFA726', // Orange 400
      light: '#FFD95B',
      dark: '#C77800',
      contrastText: '#000',
    },
    info: {
      main: '#29B6F6', // Blue 400
      light: '#6EC6FF',
      dark: '#0069C0',
      contrastText: '#000',
    },
    success: {
      main: '#66BB6A', // Green 400
      light: '#98EE99',
      dark: '#338a3e',
      contrastText: '#000',
    },
    background: {
      default: '#222222',
      paper: '#333333',
    },
    text: {
      primary: '#F7F7F7',
      secondary: '#CCCCCC',
    },
  },
  ...common,
});

export { lightTheme, darkTheme };
